export interface RestResponse<ResultType> {
  result: ResultType;
}

export class ResponseErrorData {
  constructor(
    public code: number,
    public message?: string,
    public detailMessage?: string
  ) {}
}

export interface ResponseError {
  error: ResponseErrorData;
}

export interface PageData {
  firstResult: number;
  maxResult: number;
  numOfPages: number;
  page: number;
  pageSize: number;
  total: number;
}

export interface PagedResult {
  page: PageData;
}

export enum ErrorCode {
  PACKAGE_MEMBERSHIP_ACTIVE = 7020
}



// WEBPACK FOOTER //
// src/app/common/models/rest.model.ts